import React, { useContext, useEffect } from "react"
import { render } from "react-dom"
import styled from "styled-components"
import { uniqueId, isEmpty } from "lodash"

import { ContentfulParagraph, ParagraphWithRemarkFragment } from "../../types/graphql-types"
import colors from "../utils/colors"
import { breakpoints as bp } from "../components/layout"
import ScrollableTable from "../components/ScrollableTable"
import { Large, SemiLarge, Inverted, Small } from "./globalStyle"
import { PriceContext, PriceContextType } from "../context/priceContext"
import { generateAllPriceWithCurrency, priceDataGeneratorReference } from "../utils/currencyList"
interface Props extends StylingProps {
  className?: string
  content?: ParagraphWithRemarkFragment | ContentfulParagraph
  isPlainText?: boolean
}

export interface StylingProps {
  isSmall?: boolean
  isSemiLarge?: boolean
  isLarge?: boolean
  isInverted?: boolean
  isPro?: boolean
}

const StyledParagraph = styled.div<StylingProps>`
  em {
    
    font-weight: 500;
    font-style: normal;
    ${props => (props.isPro ? `color: ${colors.dark};` : `color: ${colors.teal};`)}
  }

  a,
  a:hover,
  a:focus,
  a:visited,
  a:active {
    color: ${colors.teal};
  }

  p,
  li {
    ${props => (props.isSmall ? Small : "")}
    ${props => (props.isSemiLarge ? SemiLarge : "")}
    ${props => (props.isLarge ? Large : "")}
    ${props => (props.isInverted ? Inverted : "")}
  }

  &.gray {
    color: ${colors.gray60};
  }

  .table-scroll {
    max-width: 100%;
    overflow-x: auto;
  }

  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    color: ${colors.dark};
    td,
    th {
      border: 2px solid ${colors.tealLight3};
      font-size: 1.125em;
      font-weight: inherit;
      padding: 1.9444em 0.7661em;
    }
  }

  img {
    width: 100%;
  }
`

const Paragraph = ({
  className,
  content,
  isSemiLarge,
  isLarge,
  isInverted,
  isPro,
  isPlainText = false,
}: Props) => {
  if (isPlainText) {
    return (
      <StyledParagraph
        className={className}
        isSemiLarge={isSemiLarge}
        isLarge={isLarge}
        isInverted={isInverted}
        isPro={isPro}
      >
        <p>{content}</p>
      </StyledParagraph>
    )
  }
  if (!content || !content.paragraph?.childMarkdownRemark?.html) {
    return null
  }

  useEffect(() => {
    Array.from(document.getElementsByClassName("ScrollableTable")).forEach(element => {
      element.className = ""
      render(<ScrollableTable tableAsString={element.innerHTML} />, element)
    })
  }, [])

  const { priceData } = useContext(PriceContext) as PriceContextType
  let contentWithDynamicPrice = generateAllPriceWithCurrency(
    priceData.currency,
    priceData,
    priceData.currencySymbol,
    content.paragraph?.childMarkdownRemark?.html || ""
  )
  // Re-render tables as components to allow scrolling for table
  contentWithDynamicPrice = contentWithDynamicPrice.replace(
    /(<table>[\s\S]+<\/table>)/m,
    `<div class="ScrollableTable">$1</div>`
  )

  return (
    <StyledParagraph
      className={className}
      isSemiLarge={isSemiLarge}
      isLarge={isLarge}
      isInverted={isInverted}
      isPro={isPro}
      dangerouslySetInnerHTML={{
        __html: contentWithDynamicPrice,
      }}
    />
  )
}

export default Paragraph
